import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';

@Injectable({
  providedIn: 'root'
})
export class SelecionarTodosService {

  constructor() { }

  selecionarTodosClientes(select: MatSelect, opcao: MatOption): void {
    if (opcao.selected) {
      select.options.forEach((item: MatOption) => {
        if (item.value !== undefined) item.select();
      });
    } else {
      select.options.forEach((item: MatOption) => {
        if (item.value !== undefined) item.deselect();
      });
    }
  }

  verificarSelecionarTodos(form: FormGroup, formValue: any, opcao: MatOption, lista: Array<any>): void {
    const valoresSelecionados = form.get(formValue)?.value.filter((value: any) => value !== undefined);
    if(valoresSelecionados.length == lista.length){
      opcao.select();
    } else {
      opcao.deselect();
    }
  }
}
